__webpack_require__.p = "/reports-dashboard-templates/referrals-hub/";